import { ActivityDocument, EntityType, FilterQuery, ActivityType, CRMActivityAPIPathGenerator, APIQueryParamFragments, APIResponse } from "server-model";
import { CRMActivityConnector } from "../data-connectors";
import { AppServerConnector } from "./app-server.connector";

export class AppServerCRMActivityConnector extends AppServerConnector implements CRMActivityConnector {
    async getActivity(activityId: string, organisationId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                CRMActivityAPIPathGenerator.details(activityId),
                { ...this.getHeaders(), params: { [APIQueryParamFragments.ORGANISATION_ID]: organisationId } },
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Activity not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async listActivity(organisationId: string, entityType: EntityType, entityId: string, filterQuery: FilterQuery): Promise<APIResponse> {
        try {
            const response = await this.axios.post(
                CRMActivityAPIPathGenerator.list(),
                { filterQuery: this.toPlain(filterQuery) },
                { ...this.getHeaders(), params: { [APIQueryParamFragments.ORGANISATION_ID]: organisationId, [APIQueryParamFragments.ENTITY_TYPE]: entityType, [APIQueryParamFragments.ENTITY_ID]: entityId } },
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Activities not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async createActivity(activityDocument: ActivityDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.post(
                CRMActivityAPIPathGenerator.create(),
                { activityDocument: this.toPlain(activityDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to create activity")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async deleteActivity(activityId: string, organisationId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.delete(
                CRMActivityAPIPathGenerator.delete(activityId),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to delete activity")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async updateActivity(activityId: string, organisationId: string, activityDocument: Partial<ActivityDocument>): Promise<APIResponse> {
        try {
            const response = await this.axios.put(
                CRMActivityAPIPathGenerator.update(activityId),
                { activityDocument: this.toPlain(activityDocument) },
                { ...this.getHeaders(), params: { [APIQueryParamFragments.ORGANISATION_ID]: organisationId } },
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to update activity")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getAllActivitySpecificType(organisationId: string, activityType: ActivityType | string, filterQuery: FilterQuery): Promise<APIResponse> {
        try {
            const response = await this.axios.post(
                CRMActivityAPIPathGenerator.listSpecificType(activityType),
                { filterQuery: this.toPlain(filterQuery) },
                { ...this.getHeaders(), params: { [APIQueryParamFragments.ORGANISATION_ID]: organisationId } },
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Activities not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getAllActivitySpecificTypeSpecificEntity(organisationId: string, entityType: EntityType, entityId: string, activityType: ActivityType | string, filterQuery: FilterQuery): Promise<APIResponse> {
        try {
            const response = await this.axios.post(
                CRMActivityAPIPathGenerator.listSpecificTypeSpecificEntity(entityType, entityId, activityType),
                { filterQuery: this.toPlain(filterQuery) },
                { ...this.getHeaders(), params: { [APIQueryParamFragments.ORGANISATION_ID]: organisationId } },
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Activities not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}